import { useContext } from 'react';
import { ReservoirClientContext } from '../ReservoirClientProvider';

export default function () {
  return useContext(ReservoirClientContext);
}
